import { render } from "./create-question.vue?vue&type=template&id=59325e33&ts=true"
import script from "./create-question.vue?vue&type=script&lang=ts"
export * from "./create-question.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__